const formatLabel = {
  creation: 'creó el equipo.',
  changeStatusT: 'Inactivó',
  changeStatusT1: 'el equipo',
  changeStatusF: 'Reactivó',
  changeStatusF1: 'el equipo.',
  changeMaintenanceStatusT: 'regresó',
  changeMaintenanceStatusT1: 'el equipo de mantenimiento.',
  changeMaintenanceStatusF: 'envió',
  changeMaintenanceStatusF1: 'el equipo para mantenimiento.',
  changePlace: ' modificó el lugar de ',
  changePlace1: ' por ',
  changePlace2: ' eliminó el lugar ',
  changePlace3: ' del equipo.',
  changePlace4: ' modificó el lugar para ',
  changeSite: ' modificó el sitio de ',
  changeSite1: ' por ',
  changeSite2: ' eliminó el sitio ',
  changeSite3: ' del equipo.',
  changeSite4: ' modificó el sitio para ',
  changePhoto: ' modificó la foto.',
  changeEquipmentModel: ' actualizó el tipo de equipo de ',
  changeEquipmentModel1: ' por ',
  changeEquipmentModel2: ' eliminó el tipo de equipo ',
  changeEquipmentModel3: ' modificó el tipo de equipo para ',
  changeCompany: ' actualizó la empresa de ',
  changeCompany1: ' para ',
  changeCompany2: ' eliminó la empresa ',
  changeCompany3: ' del equipo.',
  changeCompany4: ' modificó la empresa para ',
  changeReference: ' actualizó el punto de referencia ',
  changeReference1: 'de ',
  changeReference2: ' para ',
  changeSerialNumber: ' número de serie actualizado ',
  changeSerialNumber1: 'de ',
  changeSerialNumber2: ' para ',
  changeDescription: ' actualizó las especificaciones de equipo ',
  changeDescription1: 'de ',
  changeDescription2: ' para ',
  changeBrand: ' actualizó la marca del equipo ',
  changeBrand1: 'de ',
  changeBrand2: ' para ',
  changeBrand3: ' actualizó la marca del equipo para ',
  default: 'Este equipo fue actualizado.',
  removedCompanies: 'eliminó las empresas',
  removedCompany: 'eliminó la empresa',
  addedCompanies: 'agregó las empresas',
  addedCompany: 'agregó la empresa',
  andString: 'y',
};

export default formatLabel;
